import logo from './logo.svg';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { AppRouter } from './appRouter'

function App() {
  axios.interceptors.request.use(
    (config) => {
     const jwt = JSON.parse(sessionStorage.getItem("nln-virtual-library-user-token"));
     const token = jwt ? jwt.data.token : null;
     console.log(token);
     if (token) {
       config.headers.Authorization = `Bearer ${token}`;
     }
 
     return config;
   },
   (error) => {
     return Promise.reject(error);
   }
 );


  return (
    <div>



      <ToastContainer />

      <AppRouter />

    </div>
  );
}

export default App;
